import { startAuthentication } from '@simplewebauthn/browser';
import { api, ApiError } from './api';
import { clockTime, h, main } from './dom';
import { returnTo } from './me';
import { lockup } from './logo';

const supportsPasskeys = () => typeof window.PublicKeyCredential === 'function';

export function renderSignIn(lede?: string) {
  const m = main(); m.replaceChildren();
  document.title = 'Sign in · infinidie';
  const error = h('p', { class: 'error', role: 'alert', hidden: true });
  const input = h('input', { type: 'email', id: 'email', name: 'email', autocomplete: 'username webauthn', inputmode: 'email', required: true, spellcheck: 'false', autocapitalize: 'none' });
  const send = h('button', { type: 'submit', class: 'primary' }, 'Send me a sign-in link');
  const form = h('form', { novalidate: true },
    h('label', { class: 'field', for: 'email' }, h('span', {}, 'Your email address'), h('span', { class: 'hint' }, 'We’ll email you a link. No password needed.'), input),
    error,
    h('div', { class: 'row' }, send),
  );
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = input.value.trim();
    error.hidden = true;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { error.textContent = 'Please enter a full email address, like name@example.com.'; error.hidden = false; input.focus(); return; }
    try { localStorage.setItem('myoa.lastEmail', email); } catch { /* fine */ }
    send.disabled = true; send.textContent = 'Sending…';
    try {
      await api('POST', '/api/auth/email', { email });
      renderCheckEmail(email);
    } catch (err) {
      error.textContent = (err as ApiError).message; error.hidden = false;
      send.disabled = false; send.textContent = 'Send me a sign-in link';
    }
  });

  m.append(
    h('h1', { class: 'brand-hero' }, lockup({ hero: true }).el),
    h('p', { class: 'lede' }, lede ?? 'Stories you play, alone or with friends, told by an AI storyteller.'),
    form,
  );
  if (supportsPasskeys()) {
    const pk = h('button', { type: 'button' }, 'Sign in with a passkey instead');
    pk.addEventListener('click', () => void passkeySignIn(pk, error));
    m.append(h('p', { class: 'row' }, pk));
  }
  input.focus({ preventScroll: true });
}

async function passkeySignIn(button: HTMLButtonElement, error: HTMLElement) {
  error.hidden = true; button.disabled = true; button.textContent = 'Waiting for your passkey…';
  try {
    const optionsJSON = await api<Parameters<typeof startAuthentication>[0]['optionsJSON']>('POST', '/api/passkey/login/options');
    const response = await startAuthentication({ optionsJSON });
    await api('POST', '/api/passkey/login/verify', { response });
    location.replace(returnTo.take() ?? location.pathname);
  } catch {
    error.textContent = 'That didn’t work. Try again, or use an email link.'; error.hidden = false;
    button.disabled = false; button.textContent = 'Sign in with a passkey instead';
  }
}

function renderCheckEmail(email: string) {
  const m = main(); m.replaceChildren();
  const again = h('button', { type: 'button' }, 'Use a different email');
  again.addEventListener('click', () => renderSignIn());
  m.append(
    h('h1', {}, 'Check your email'),
    h('p', { role: 'status', class: 'lede' }, `If ${email} is on the invite list, a sign-in link is on its way (sent ${clockTime()}). It works once, for 15 minutes.`),
    h('p', {}, 'Open the email on this device and tap the link. You can close this page.'),
    h('p', { class: 'row' }, again),
  );
  m.focus();
}
